var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    stroke: "white",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 6.66667H21.0889C19.0354 6.66667 18.0086 6.66667 17.2243 7.06631C16.5343 7.41785 15.9734 7.97877 15.6219 8.6687C15.2222 9.45304 15.2222 10.4798 15.2222 12.5333V14M25 6.66667L21.3333 3M25 6.66667L21.3333 10.3333M11.5556 3H8.86667C6.81314 3 5.78638 3 5.00203 3.39964C4.31211 3.75118 3.75118 4.31211 3.39964 5.00203C3 5.78638 3 6.81314 3 8.86667V19.1333C3 21.1869 3 22.2136 3.39964 22.998C3.75118 23.6879 4.31211 24.2488 5.00203 24.6004C5.78638 25 6.81314 25 8.86667 25H19.1333C21.1869 25 22.2136 25 22.998 24.6004C23.6879 24.2488 24.2488 23.6879 24.6004 22.998C25 22.2136 25 21.1869 25 19.1333V16.4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.90f473c0129e7887c2a95d7e5422cc33.svg";
export { ForwardRef as ReactComponent };